<template>
  <div id="player-lookup" class="row mb-3">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-2 col-xs-12">
              <Combat class="mb-2" :stats="player"></Combat>
            </div>
            <div class="col-md-10 col-xs-12">
              <div class="input-group">

                <b-dropdown split id="dropdown-1">
                  <template v-slot:button-content>
                    <img loading="lazy" sizes="100%, 100%" class="img-fluid" :alt="ucHuman(activeMode)"
                         :title="ucHuman(activeMode)" :src="activeModeImg">
                  </template>

                  <b-dropdown-item v-for="(mode,idx) in gameModes" :key="idx" @click="activeMode = mode.name">
                    <img loading="lazy" sizes="100%, 100%" :alt="ucHuman(mode.name)" :title="ucHuman(mode.name)"
                         :src="mode.icon">
                    {{ucHuman(mode.name)}}
                  </b-dropdown-item>

                </b-dropdown>

                <input v-on:keyup.enter="lookup" v-model="input" class="form-control" placeholder="Runescape Username"
                       :disabled="loading">
                <button :disabled="loading" type="button" class="btn btn-sm btn-primary" @click="lookup">{{loading ?
                  'Loading...' :
                  'Lookup'}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import EquipmentBonus from "./gear-selector/EquipmentBonus";
  import Combat from "./stats/Combat";

  export default {
    name: "PlayerLookup",
    components: {Combat, EquipmentBonus},
    props: {
      settings: {
        type: Object,
      },
      player: {
        type: Object,
      }
    },
    data() {
      return {
        loading: false,
        activeMode: 'normal',
        input: '',
        gameModes: [
          {
            name: "normal",
            icon: '/static/images/icons/game_modes/normal.png'
          },
          {
            name: "ironman",
            icon: '/static/images/icons/game_modes/ironman.png'
          },
          {
            name: "hardcore_ironman",
            icon: '/static/images/icons/game_modes/hardcore_ironman.png'
          },
          {
            name: "ultimate_ironman",
            icon: '/static/images/icons/game_modes/ultimate_ironman.png'
          }
        ]
      }
    },
    computed: {
      activeModeImg: function () {
        return `/static/images/icons/game_modes/${this.activeMode}.png`
      }
    },
    methods: {
      lookup: function () {
        console.log('Getting stats for username', this.input);
        this.loading = true;

        let uri = `${process.env.API_ADDR}/players/search`;

        console.log('Checking highscores:', uri);

        this.$http.post(uri, {
          username: this.input,
          mode: this.activeMode
        }).then((resp) => {
          this.loading = false;
          console.log('highscore result', resp);

          if(resp.data.error) {
            this.$toasted.show('Highscore lookup error', {duration: 5000});
            this.$emit('lookup', {
              attack: {level: 99},
              strength: {level: 99},
              defence: {level: 99},
              magic: {level: 99},
              hitpoints: {level: 99},
              ranged: {level: 99},
              prayer: {level: 99}
            });

            return
          }

          this.$toasted.show('User stats imported!', {duration: 2000});
          this.handleResult(resp.data)
        }).catch(error => {
          console.error(error);
          this.loading = false;

          this.$emit('lookup', {
            attack: {level: 0},
            strength: {level: 0},
            defence: {level: 0},
            magic: {level: 0},
            hitpoints: {level: 0},
            ranged: {level: 0},
            prayer: {level: 0}
          });
          this.query = '';

          this.$toasted.show('Invalid Username', {duration: 2000});
        });

      },

      handleResult: function (player) {
        localStorage.setItem("osrs:compare:player", JSON.stringify(player));

        this.$emit('lookup', player)
      }
    },
    mounted() {
      const playerStats = JSON.parse(localStorage.getItem("osrs:compare:player"));

      if (playerStats !== null) {
        this.input = playerStats.player;
        this.$emit('lookup', playerStats)
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/PlayerLookup.vue